<template>
  <div id="contribute-team" class="contribute-team">
    <div
      v-for="(item, index) in list"
      :key="index"
      :class="index == 0 ? 'person team-item' : 'team-item'"
    >
      <div class="h">
        <div class="img">
          <img :src="item.avatar" alt="" />
        </div>
        <div class="text">
          <div class="left">
            <div class="t">
              <span v-if="item.type == 1" class="leader">团长</span>
              {{ item.realname }}
            </div>
            <div class="p">
              {{ item.mobile }}
            </div>
          </div>
          <div class="right">
            <span @click="goDetail(item)">查看详情</span>
          </div>
        </div>
      </div>
      <div class="b">
        <ul class="file-list">
          <li v-for="(li, liIndex) in item.imgs" :key="liIndex">
            <div class="img"><img :src="li.image" alt="" /></div>
          </li>
        </ul>
      </div>
    </div>
    <footer>
      <Tips :curCount="teamInfo.workscount" :member="teamInfo.membercount" />
    </footer>
  </div>
</template>

<script>
import Tips from "@/components/GroupTips";
export default {
  components: {
    Tips,
  },
  data() {
    return {
      bgImg: [
        require("@/static/images/group/i-1.png"),
        require("@/static/images/group/i-8.png"),
      ],
      // demo: require("@/static/images/pic-6.png"),
      id: this.$route.params.id,
      tid: this.$route.query.tid,
      uid: this.$route.query.uid,
      teamInfo: {},
      list: [],
    };
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: "/detail/" + this.id + "/team-detail",
        query: {
          uid: item.uid,
          gid: this.$route.query.gid,
        },
      });
    },
  },
  created() {
    console.log(this.tid, this.uid);
    this.axios.post(this.tools.api.teamInfo, { tid: this.tid }).then((res) => {
      console.log(res);
      // this.list = res.data.data.member;
      this.teamInfo = res.data.data.team;
      let list = res.data.data.member;
      let curIndex = 0;
      for (let i = 0, len = list.length; i < len; i++) {
        if (list[i].uid == this.uid) {
          curIndex = i;
          break;
        }
      }
      if (curIndex != 0) {
        let item = [];
        item[0] = list[curIndex];
        list.splice(curIndex, 1);
        this.list = item.concat(list);
      } else {
        this.list = list;
      }
      console.log(this.list);
    });
  },
};
</script>

<style lang="scss" scoped>
.contribute-team {
  background: #f5f8fa;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 60px;

  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .leader {
    width: 86px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: #{"12PX"};
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    color: #fff;
    display: inline-block;
    background: linear-gradient(to right, #c5905d, #f5c594);
  }
}
.team-item {
  padding: 30px;
  .h {
    overflow: hidden;
    .img {
      float: left;
      margin-right: 22px;
      width: 64px;
      height: 64px;
      padding: 4px;
      border-radius: 50%;
      background-image: linear-gradient(to right, #ff5026, #ffcdb5);
      img {
        background: #fff;
        max-width: 100%;
        max-height: 100%;
        display: block;
        border-radius: 50%;
      }
    }
    .text {
      padding: 2px 0 0;
      .t {
        color: #666;
        font-size: 22px;
        .ico {
          margin-right: 5px;
        }
      }
      .p {
        padding: 8px 0 0;
        font-size: 18px;
      }
    }
    .left {
      color: #666;
      height: 36px;
      line-height: 36px;
      padding: 0 5px;
      display: inline-block;
    }
    .right {
      color: #fff;
      float: right;
      padding-top: 10px;
      span {
        height: 44px;
        line-height: 44px;
        width: 140px;
        border-radius: 8px;
        text-align: center;
        color: #fff;
        background-image: linear-gradient(to right, #f77e5e, #ffa265);
        display: inline-block;
        font-size: 21px;
        margin: 0 5px;
      }
    }
  }
  .b {
    .file-single {
      padding: 22px 0 0;
    }
    .file-list {
      white-space: nowrap;
      overflow: auto;
      &::-webkit-scrollbar {
        height: 0;
      }
      li {
        border-radius: 8px;
        display: inline-block;
        background: #fff;
        width: 200px;
        height: 200px;
        margin: 15px 15px 0 0;
        vertical-align: top;
        .t1 {
          font-size: 18px;
          line-height: 34px;
        }
        .b1 {
          font-size: 14px;
          line-height: 20px;
        }
        .img {
          width: 100%;
          height: 100%;
        }
        img {
          position: relative;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-height: 100%;
          max-width: 100%;
        }
      }
      li:last-child {
        margin-right: 0;
      }
      .ico-add {
        background-position: 0 -50px;
        width: 50px;
        height: 50px;
        margin-top: 34px;
      }
    }
  }
}
.person {
  background: #fff8f6;
}
</style>
